import React from "react";
import { useNavigate } from "react-router-dom";

import BgFrame from "../../../Components/Common/BgFrame";
import MobileViewContainer from "../../../Components/MobileViewContainer";
import { CheckoutHeader } from "../components";
import MultiOrderProcess from "./MultiOrderProcess";

const OrderTicketMultiPage = () => {
  const navigate = useNavigate();

  return (
    <MobileViewContainer>
      <CheckoutHeader title="티켓 결제" onBack={() => navigate(-1)} showProgress={false} />
      <BgFrame>
        <MultiOrderProcess />
      </BgFrame>
    </MobileViewContainer>
  );
};

export default OrderTicketMultiPage;
